import { Presentation } from './productPresentation.style';
import CardProduct from '../cards/card-product/cardProduct';
import { PresentationConfig } from '../../models/auto-generated-strapi-types/types/components/PresentationConfig';
import { Product } from '../../models/auto-generated-strapi-types/types/Product';

interface ProductPresentationProps {
  presentationConfigs: PresentationConfig;
  products: Product[];
}

const getProductCards = (products: Product[]) => {
  return products.map((product) => {
    return <CardProduct product={product} />;
  });
};

const ProductPresentation: React.FC<ProductPresentationProps> = ({
  products,
  presentationConfigs,
}) => {
  return (
    <>
      {products && (
        <Presentation elementsNr={presentationConfigs}>
          {getProductCards(products || [])}
        </Presentation>
      )}
    </>
  );
};

export default ProductPresentation;
